import React from 'react';
import styles from './styles.module.css';

export default () => (
  <div className={styles.container}>
    <div />
    <div />
    <div />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/loading-indicator/index.js